import React from 'react'
import './MaintenancePage.scss'

const MaintenancePage = () => (
  <div className='maintenance-page'>
    <div className='maintenance-page__content'>
      <img src='/logo_bg.png' alt='logo' className='maintenance-page__logo' />
      <h1 className='maintenance-page__title'>Mentenanță în desfășurare</h1>
      <p className='maintenance-page__subtitle'>
        Aplicația este temporar indisponibilă. Vă rugăm să reveniți în curând.
      </p>
    </div>
  </div>
)

export default MaintenancePage
